import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { DistrictMiniEntity } from '../../domain/entities/DistrictsMiniEntity'
import type { DistrictRegionAdminDto } from '@/backend/market'

export class DistrictMiniModel extends DistrictMiniEntity {
  constructor(dataDto: DistrictRegionAdminDto) {
    super()
    mapEntityProperties<DistrictMiniEntity>(this, dataDto)
  }
}
